import { render } from "./PrivacyAcceptedUsers.vue?vue&type=template&id=61b447c9&scoped=true"
import script from "./PrivacyAcceptedUsers.vue?vue&type=script&lang=js"
export * from "./PrivacyAcceptedUsers.vue?vue&type=script&lang=js"

import "./PrivacyAcceptedUsers.vue?vue&type=style&index=0&id=61b447c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b447c9"]])

export default __exports__